import {
  loadFeedData,
  storeFeedSections,
} from 'src/components/navigation/feed_store.js'
import NavigationEntry from 'src/components/navigation/navigation_entry.vue'
import TimelineSettingsMenu from 'src/components/timeline_settings_menu/timeline_settings_menu.vue'

// Every feed, in groups: the one place to switch feeds
export default {
  components: { NavigationEntry, TimelineSettingsMenu },
  props: {
    // the timeline settings as a last row (the phone: it has no header row)
    settings: Boolean,
    // a pin button on each feed (the desktop: pinned feeds show in the header)
    pinnable: Boolean,
  },
  created() {
    loadFeedData()
  },
  computed: {
    sections() {
      return storeFeedSections()
    },
  },
}
